import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch audit logs
export const getAuditLogs = createAsyncThunk(
    "sudit-logs/getAuditLogs",
    async ({ token, offset = 1, limit = 15 }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/audit-logs`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        offset: offset,
                        limit: limit
                    }
                }
            );
            if (response.data.status) {
             
                return { offset, response: response.data.response };
            } else {
                return rejectWithValue("Failed to fetch ");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || "Unknown error");
        }
    }
);

const auditLogsSlice = createSlice({
    name: 'auditLogs',
    initialState: {
        logs: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAuditLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAuditLogs.fulfilled, (state, action) => {
                state.loading = false;

                 const { offset } = action.payload;
                        if (offset === 1) {
                          state.logs = action.payload.response;
                        } else {
                          const combined = [...state.logs, ...action.payload.response];
                          state.logs = combined;
                        }
             
            })
            .addCase(getAuditLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                
            });
    },
});

export default auditLogsSlice.reducer;